var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.33333C17 6.622 15.9553 7.66667 14.6667 7.66667C13.7532 7.66667 12.9623 7.14173 12.5792 6.37706C12.4219 6.063 12.3333 5.70851 12.3333 5.33333C12.3333 4.04467 13.378 3 14.6667 3C15.9553 3 17 4.04467 17 5.33333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.6667C17 15.9553 15.9553 17 14.6667 17C13.378 17 12.3333 15.9553 12.3333 14.6667C12.3333 14.2915 12.4219 13.937 12.5792 13.6229C12.9623 12.8583 13.7532 12.3333 14.6667 12.3333C15.9553 12.3333 17 13.378 17 14.6667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 10C7.66667 10.3752 7.57812 10.7297 7.42079 11.0437C7.03771 11.8084 6.24682 12.3333 5.33333 12.3333C4.04467 12.3333 3 11.2887 3 10C3 8.71134 4.04467 7.66667 5.33333 7.66667C6.24682 7.66667 7.03771 8.1916 7.42079 8.95627C7.57812 9.27033 7.66667 9.62482 7.66667 10Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42079 11.0437C7.57812 10.7297 7.66667 10.3752 7.66667 10C7.66667 9.62482 7.57812 9.27033 7.42079 8.95627M7.42079 11.0437C7.03771 11.8084 6.24682 12.3333 5.33333 12.3333C4.04467 12.3333 3 11.2887 3 10C3 8.71134 4.04467 7.66667 5.33333 7.66667C6.24682 7.66667 7.03771 8.1916 7.42079 8.95627M7.42079 11.0437L12.5792 13.6229M7.42079 8.95627L12.5792 6.37706M12.5792 6.37706C12.9623 7.14173 13.7532 7.66667 14.6667 7.66667C15.9553 7.66667 17 6.622 17 5.33333C17 4.04467 15.9553 3 14.6667 3C13.378 3 12.3333 4.04467 12.3333 5.33333C12.3333 5.70851 12.4219 6.063 12.5792 6.37706ZM12.5792 13.6229C12.4219 13.937 12.3333 14.2915 12.3333 14.6667C12.3333 15.9553 13.378 17 14.6667 17C15.9553 17 17 15.9553 17 14.6667C17 13.378 15.9553 12.3333 14.6667 12.3333C13.7532 12.3333 12.9623 12.8583 12.5792 13.6229Z",
    stroke: "#6366F1",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.52fae49385b2c934970052713fe1613d.svg";
export { ForwardRef as ReactComponent };